declare namespace $ {

	export class $bog_blitz_admin_bot extends $giper_bot {
		Space( ): any
		dialog_title( next?: string ): string
		on_quiz( next?: any ): any
	}
	
}

//# sourceMappingURL=bot.view.tree.d.ts.map